import { render, staticRenderFns } from "./supplier-sel-page.vue?vue&type=template&id=8b721c2c&scoped=true"
import script from "./supplier-sel-page.vue?vue&type=script&lang=js"
export * from "./supplier-sel-page.vue?vue&type=script&lang=js"
import style0 from "./supplier-sel-page.vue?vue&type=style&index=0&id=8b721c2c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b721c2c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8b721c2c')) {
      api.createRecord('8b721c2c', component.options)
    } else {
      api.reload('8b721c2c', component.options)
    }
    module.hot.accept("./supplier-sel-page.vue?vue&type=template&id=8b721c2c&scoped=true", function () {
      api.rerender('8b721c2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/base-data/supplier-sel-page.vue"
export default component.exports